import { Navigate, Outlet, useLocation } from 'react-router-dom'
import Navbar from 'components/navbar/Navbar'
import 'react-toastify/dist/ReactToastify.css'
// import {ToastContainer} from 'react-toastify'
import { useEffect, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import { getRoles } from 'redux/features/general/generalSlice'
import { useDispatch } from 'react-redux'
import Sidebar from 'components/sidebar/Sidebar'

// Login olmadan erişilebilen (sadece görüntüleme) sayfa yolu
const PUBLIC_WEEKLY_PLAN_DETAIL_PATH = /^\/weekly-plan\/[^/]+$/

const Layout = () => {
	const [authData, setAuthData] = useState(JSON.parse(localStorage.getItem('auth')))
	const [getAllRoles] = useRequest()
	const dispatch = useDispatch()
	const location = useLocation()
	const isPublicWeeklyPlanDetail = PUBLIC_WEEKLY_PLAN_DETAIL_PATH.test(location.pathname)

	useEffect(() => {
		setAuthData(JSON.parse(localStorage.getItem('auth')))
		if (authData?.token) {
			getAllRoles('/Role/GetAllRoles', { method: 'GET' }).then(res => {
				dispatch(getRoles(res.data.result))
			})
		}
	}, [])

	// Token yok: sadece haftalık plan detay (link ile paylaşım) için sayfayı göster, diğer tüm yollar login'e
	if (!authData?.token) {
		if (isPublicWeeklyPlanDetail) {
			return <Outlet />
		}
		return <Navigate to='/login' />
	}

	return (
		<div className='layout'>
			<Sidebar />
			<div className='layout-main-container'>
				<Navbar />
				<Outlet />
			</div>
		</div>
	)
}

export default Layout
